import { forwardRef, type ChangeEvent, type ComponentPropsWithoutRef } from 'react';

import { cx } from './internal/cx.js';

export type TextareaProps = Omit<
  ComponentPropsWithoutRef<'textarea'>,
  'onChange' | 'value' | 'defaultValue'
> & {
  value: string;
  onChange: (value: string) => void;
};

/** Controlled native textarea styled like TextInput. Requires `@import '@nrx/ui/theme.css'`. */
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { value, onChange, className, ...props },
  ref,
): React.JSX.Element {
  const handleChange = (event: ChangeEvent<HTMLTextAreaElement>): void => {
    onChange(event.target.value);
  };

  return (
    <textarea
      ref={ref}
      value={value}
      className={cx('input', 'textarea', className)}
      onChange={handleChange}
      {...props}
    />
  );
});
